export default {
  alertasArray: [],
  tipos: [1, 2, 3]
}